<template>
  <div class="type_number" :class="{ loading }">
    <div class="loading_spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <ElTooltip :content="statusMessage">
      <div class="status" :class="status"></div>
    </ElTooltip>
    <div class="value">{{ value }}</div>
    <div class="title">
      {{ declOfNum(value, ["Сертификат", "Сертификата", "Сертификатов"]) }}
      нужно обновить
    </div>
  </div>
</template>

<script>
let apiDriver = require("../../apiDriver").default;
let moment = require("moment");
import { Tooltip } from "element-ui";

export default {
  name: "admin_certExpire",
  components: {
    [Tooltip.name]: Tooltip,
  },
  data: function () {
    return {
      loading: true,
      value: 0,
      status: "",
      statusMessage: "",
    };
  },
  methods: {
    moment,
    declOfNum: function (number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    getData: async function () {
      this.loading = true;

      let users = (await apiDriver.admin.users.cardsCerts.get()).users;
      for (let u of users) {
        let cert_moment = moment(u.cards_cert_expire, "YYYY-MM-DD");
        u.cards_cert_expire = cert_moment.clone().format("DD.MM.YYYY");
        if (cert_moment < moment()) {
          u.certHighlight = "red";
        } else {
          if (cert_moment.clone().diff(moment(), "days") < 30) {
            u.certHighlight = "yellow";
          } else {
            u.certHighlight = "green";
          }
        }
      }
      this.value = users.filter((x) => x.certHighlight == "yellow").length;

      if (this.value == 0) {
        this.status = "green";
        this.statusMessage = "Все сертификаты обновлены";
      } else {
        this.status = "orange";
        this.statusMessage = "Необходимо обновить сертификаты";
      }

      this.loading = false;
    },
  },
  mounted: function () {
    this.getData();
  },
};
</script>